import React from 'react';
import ToggleSwitch from '../../../Components/ToggleSwitch';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { CustomMultiValue, CustomOption } from '../../../Components/SelectCustomComponents';

interface StatusConfirmationFieldsProps {
    processType: string;
    toggles: any;
    handleToggleChange: (key: string, value: boolean) => void;
    multiStatus: any[];
    setMultiStatus: (status: any[]) => void;
    defaultStatus: any[];
}

const StatusConfirmationFields: React.FC<StatusConfirmationFieldsProps> = ({ 
    processType, 
    toggles, 
    handleToggleChange, 
    multiStatus, 
    setMultiStatus, 
    defaultStatus 
}) => {
    return (
        <div className={`col-md-6`}>
            <div className={`col-md-12`}>
                <ToggleSwitch
                    label="Require status confirmation"
                    labelStyle="ms-2 fw-600"
                    checked={toggles.isStatusConfirmation}
                    onChange={(value: any) => handleToggleChange("isStatusConfirmation", value)}
                    isDisabled={processType === "CTPAT"}
                />
            </div>
            <div className={`col-md-12 mt-0`}>
                {processType === "CTPAT" ? (
                    <Select
                        isMulti
                        options={[...defaultStatus]}
                        name="multiStatus"
                        value={multiStatus}
                        onChange={() => { }}
                        placeholder={"Select multi status..."}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        isDisabled={true}
                        styles={{
                            control: (provided: any) => ({
                                ...provided,
                                minHeight: "42px",
                            }),
                        }}
                    />
                ) : (
                    <CreatableSelect
                        isMulti
                        options={[]}
                        name="multiStatus"
                        value={multiStatus}
                        onChange={(selected:any) => setMultiStatus(selected)}
                        placeholder={"Enter multi status..."}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        isDisabled={!toggles.isStatusConfirmation}
                        styles={{
                            control: (provided: any) => ({
                                ...provided,
                                minHeight: "42px",
                            }),
                        }}
                    />
                )}
                {toggles.isStatusConfirmation && multiStatus.length === 0 ? (
                    <small className="text-danger ms-2 fw-700">status is required</small>
                ) : toggles.isStatusConfirmation && processType !== "CTPAT" ? (
                    <small className="ms-2 fst-italic">Press enter to add new option</small>
                ) : null}
            </div>
        </div>
    );
};

export default StatusConfirmationFields;
